import { ParameterType } from '@/study-search/enums';

import { Filter } from '../Filter';
import { IIndexation } from '../../../interfaces';
import { DurationFilterOptionValue, FilterKey } from '@studyportals/search-filters/server-side';

export class DurationFilter extends Filter implements IIndexation {
	public constructor() {
		super(FilterKey.DURATION, ParameterType.DURATION, []);
	}

	public canBeIndexed(): boolean {
		return (
			this.values.length === 1 &&
			(this.values.includes(DurationFilterOptionValue.ONE_YEAR) ||
				this.values.includes(DurationFilterOptionValue.TWO_YEARS) ||
				this.values.includes(DurationFilterOptionValue.THREE_YEARS) ||
				this.values.includes(DurationFilterOptionValue.FOUR_YEARS) ||
				this.values.includes(DurationFilterOptionValue.LESS_THAN_ONE_MONTH))
		);
	}
}
